// The following line fixes ts-1363 error. @TODO: Add to @bb/eslint-config
/* eslint-disable import/no-duplicates */
import _ from 'lodash';
import moment from 'moment';
import errorReporter from '@app/errorReporter';
import 'pretty-checkbox';
import { message } from 'antd';

import type {
  IAnchorScrollService,
  IFormController,
  ILocationService,
  IQService,
  IScope,
  ITimeoutService,
} from 'angular';
import type {
  AccessKey,
  AccessType,
  ConfigContact,
  ConfirmationInstructions,
  DAYS,
  NotificationLabels,
  TIMES,
  TimesStatus,
} from '@bb/domain/dist/types/AppointmentConfig';
import type Contact from '@bb/domain/dist/types/Contact';
import type AppointmentConfig from '@bb/domain/dist/types/AppointmentConfig';
import type AnsweringSubscription from '@bb/domain/dist/types/AnsweringSubscription';
import type { AccessHoursType } from '@bb/domain/dist/types/SupraLockbox';

import fileStackClient from '@app/filestack';
import { Modal } from 'components';
import {
  makeModalResponsive,
  isLimitedAccessOnUnclaimedBrokerage,
  MAX_NOTICE_IN_MINUTES,
  buildLockboxRestrictedHoursMap,
  parseAccessHours,
  buildDKCoreDeviceAccessHours,
  featureEnabled,
  isValidUrl,
} from 'utils';
import type { AppointmentStatus } from '@bb/domain/dist/types';
import parseInstructions from 'utils/parseInstructions';
import type { UserRoles } from '@bb/users';
import { ROLES } from '@bb/users';
import type { AuthContextUser } from 'contexts';
import { areAppointmentInstructionsInvalid } from './areAppointmentInstructionsInvalid';
import pageTemplate from './appointment_config.html';
import type { VirtualTourData } from './VirtualShowingSettings';
import type { ShowingSettingsProps } from './ShowingSettings';
import ConfirmMustCallModal from './ConfirmMustCallModal';

type todo = any;
type FIXME = any;
type IResource<T = any> = ng.resource.IResourceClass<ng.resource.IResource<T>>;
type AppointmentConfigSwitch = 'appointment';
type GetLockboxTypesForListingDTO = {
  supra: boolean;
  masterLock: boolean;
  sentriLock: boolean;
  combinationLockbox: boolean;
};

class AppointmentConfigCtrl {
  private appointmentConfigSwitch: AppointmentConfigSwitch;
  private isModal: boolean;
  private showLockboxPhotoEditor: boolean;
  private listingId: string;
  private appointmentId: string;
  private Listing: IResource;
  private AppointmentConfig: IResource;
  private LockboxTypes: IResource;
  private LockboxAccessHours: IResource;
  private SetLAToConfirm: IResource;
  private SpatulaDomain: IResource;
  private AnsweringSubscription: IResource;
  private UseAppointmentDesk: IResource;
  private listing: todo;
  private config: todo;
  private appointmentConfig: AppointmentConfig;
  private supraLockboxAccessHours?: AccessHoursType<Date>;
  private supraLockboxRestrictedHoursMap?: Record<string, string[]>;
  private lockboxTypes?: GetLockboxTypesForListingDTO;
  private answeringSubscription: AnsweringSubscription;
  private showSupraAccessOptions: boolean;
  private showMasterLockAccessOptions: boolean;
  private showSentriLockAccessOptions: boolean;
  private showCombinationLockboxOptions: boolean;
  private newLockboxPhoto: boolean;
  private showAlarmInstruction: boolean;
  private showOtherInstruction: boolean;
  private isSentriLockCodeValid: boolean;
  private isVirtualTourUrlValid: boolean;
  private dataLoaded: boolean;
  private isMasterLockCodeValid: boolean;
  private isSupraLockCodeValid: boolean;
  private lockboxPhoto: string;
  private disableAutoConfirm: boolean;
  private validatingSentriLock: boolean;
  private shouldGetLockboxes: boolean;
  private isInvalidNotice: boolean;
  private contact: Contact;
  private answeringSubscriptionExists: boolean;
  private useAppointmentDeskChanged: boolean;
  private approveShowingOptions: Pick<
    AppointmentConfig,
    'autoConfirm' | 'listingAgentConfirm'
  >;

  private auth: AuthContextUser;

  private originalShowingsConfig: AppointmentConfig;
  private updateShowingsVisible: boolean;
  private excludedShowings: AppointmentStatus[];
  private saveShowingsConfig: () => void;

  private isMustCallDisabled: boolean;
  private setIsMustCallDisabled: (val: boolean) => void;

  virtualTourUrl: string;
  contactsToConfirm: boolean;
  showVendorInstruction: boolean;

  // @TODO: Add this to @bb/eslint-config
  // https://github.com/typescript-eslint/typescript-eslint/blob/master/packages/eslint-plugin/docs/rules/no-useless-constructor.md
  // eslint-disable-next-line no-useless-constructor
  constructor(
    private $scope: IScope,
    private $resource: ng.resource.IResourceService,
    private $rootScope: any,
    private $location: ILocationService,
    private $routeParams: ng.route.IRouteParamsService,
    private $timeout: ITimeoutService,
    private $q: IQService,
    private $anchorScroll: IAnchorScrollService,
    private loadContacts: todo,
    private NoMoreShowingsService: todo,
    private ToastService: todo,
    private AppointmentConfigService: todo,
    private ErrorService: todo,
    private ModalService: todo,
  ) {}

  // #region Lifecycle Methods

  $onInit = () => {
    const { $resource, $q, $rootScope } = this;
    this.appointmentConfigSwitch = 'appointment';
    this.isModal = $('appointmentConfigModal').length > 0;
    this.showLockboxPhotoEditor = false;
    this.listingId =
      this.listingId || this.$routeParams.id || this.$routeParams.listingId;
    this.appointmentId = this.appointmentId || this.$routeParams.appointmentId;
    this.useAppointmentDeskChanged = false;
    const { listingId } = this;
    this.updateShowingsVisible = false;
    this.isMustCallDisabled = false;
    this.auth = $rootScope.auth;
    this.setIsMustCallDisabled = val => {
      this.isMustCallDisabled = val;
    };
    this.Listing = $resource(`/listing/${listingId}`);
    this.AppointmentConfig = $resource(
      `/listing/${listingId}/appointments/config`,
    );
    this.LockboxTypes = $resource(
      `/listing/${listingId}/appointments/lockbox_types`,
    );
    this.LockboxAccessHours = $resource(`/supra/:serialNumber/access_hours`);
    this.SetLAToConfirm = $resource(
      `/appointments/${listingId}/config/latoconfirm`,
    );

    this.SpatulaDomain = $resource('/secrets/spatula_domain');

    this.AnsweringSubscription = $resource(
      `/listing/${listingId}/answering_subscription`,
    );

    this.UseAppointmentDesk = $resource(
      `/listing/${listingId}/change_use_appointment_desk`,
    );

    // fetching answering subscription for listing agents (in case they have one)
    this.AnsweringSubscription.get({
      listingId: this.listingId,
    }).$promise.then(
      ({ subscriptions }: { subscriptions: AnsweringSubscription[] }) => {
        const filteredSubscriptions = subscriptions.filter(
          ({ answeringServiceId }) => Boolean(answeringServiceId),
        );
        this.answeringSubscription =
          filteredSubscriptions.find(
            ({ userId }) => userId && userId.toString() === $rootScope.auth?.id,
          ) || filteredSubscriptions[0];
        this.answeringSubscriptionExists = Boolean(this.answeringSubscription);
      },
    );

    $q.all([
      this.Listing.get({ id: this.listingId }).$promise,
      this.config
        ? Promise.resolve(this.config)
        : this.AppointmentConfig.get({ listingId: this.listingId }).$promise,
      this.LockboxTypes.get({ listingId: this.listingId }).$promise,
    ])
      .then(([listing, appointmentConfig, lockboxTypes]) => {
        this.listing = listing;
        this.appointmentConfig = appointmentConfig;
        this.lockboxTypes = lockboxTypes;

        const agentIds = this.appointmentConfig.contacts
          .filter(contact => contact.type === 'Agent')
          .map(contact => contact.contactId);
        this.loadContacts($resource, this, $q, this.listingId, agentIds).catch(
          errorReporter.error,
        );

        if (this.checkAlarmInstruction()) {
          this.showAlarmInstruction = true;
        }

        if (this.checkOtherInstruction()) {
          this.showOtherInstruction = true;
        }
        if (!this.appointmentConfig.specialTimes) {
          this.appointmentConfig.specialTimes = {};
        }

        this.newLockboxPhoto = !this.appointmentConfig.lockboxPhoto;

        if (!(this.appointmentConfig as FIXME).id) {
          _.each(this.days, day => {
            this.appointmentConfig.days[day] = this.createTimesForDay();
          });
        }

        this.showSupraAccessOptions = this.lockboxTypes?.supra ?? false;
        this.showMasterLockAccessOptions =
          this.lockboxTypes?.masterLock ?? false;
        this.showSentriLockAccessOptions =
          this.lockboxTypes?.sentriLock ?? false;
        this.showCombinationLockboxOptions =
          this.lockboxTypes?.combinationLockbox ?? false;
        if (
          this.appointmentConfig.access === 'SentriLock' &&
          this.appointmentConfig.instructions.sentrilock.lbsn
        ) {
          this.isSentriLockCodeValid = true;
        }

        const originalAccess = this.appointmentConfig.access;
        const originalAccessName =
          this.accessInstructionNames[
            _.findIndex(this.accesses, item => item.id === originalAccess)
          ];
        const originalInstructions = {
          ...this.appointmentConfig.instructions[originalAccessName],
        };
        const originalLockboxPhoto = this.appointmentConfig.lockboxPhoto;

        this.approveShowingOptions = {
          autoConfirm: this.appointmentConfig.autoConfirm,
          listingAgentConfirm: this.appointmentConfig.listingAgentConfirm,
        };
        this.originalShowingsConfig = _.cloneDeep(this.appointmentConfig);

        if (appointmentConfig.access === 'Supra Lockbox') {
          this.LockboxAccessHours.get({
            serialNumber:
              appointmentConfig.instructions.supralockbox.serialNumber,
          }).$promise.then(accessHours => {
            const {
              $promise,
              $resolved,
              customerDefaultHours,
              ...deviceHours
            } = accessHours;
            const parsedHours = parseAccessHours(
              deviceHours,
              appointmentConfig.instructions.supralockbox.productCode,
            ) as AccessHoursType<Date>;
            this.supraLockboxAccessHours = parsedHours;
            this.supraLockboxRestrictedHoursMap =
              buildLockboxRestrictedHoursMap(parsedHours);
          });
        }
      })
      .catch(err => {
        const { data } = err;
        this.$location.path('/');
        if (data.type === 'FORBIDDEN_ACTION') {
          data.message =
            'You do not have permissions to view this page. Please contact support@brokerbay.com for more information.';
        }
        this.ErrorService.toastyHTTPErr({ ...err, data });
        errorReporter.error({ ...err, data });
      })
      .finally(() => {
        this.dataLoaded = true;
      });
  };

  setVirtualTourData = (data: VirtualTourData) => {
    this.$rootScope.$evalAsync(() => {
      this.appointmentConfig.isVirtualTourEnabled = data.enabled;
      this.appointmentConfig.virtualTourProvider = data.provider;
      this.appointmentConfig.virtualTourIdentifier = data.identifier;
      this.isVirtualTourUrlValid = data.valid;
    });
  };

  setShowingSettings = (showingSettings: Partial<ShowingSettingsProps>) => {
    this.$rootScope.$evalAsync(() => {
      this.appointmentConfig.notice = showingSettings.notice;
      this.appointmentConfig.noticeMinutes = showingSettings.noticeMinutes;
      this.appointmentConfig.overnightNotice = showingSettings.overnightNotice;
      this.appointmentConfig.maxDuration = showingSettings.maxDuration;
      this.appointmentConfig.doubleBookings = showingSettings.doubleBookings;
      this.appointmentConfig.maxOverlap = showingSettings.maxOverlap;
      this.appointmentConfig.bufferSlots = showingSettings.bufferSlots;
      this.appointmentConfig.notifyOverlappingAppt =
        showingSettings.notifyOverlappingAppt;
      this.appointmentConfig.showing_instructions =
        showingSettings.showingInstructions;
      this.appointmentConfig.vendor_instructions =
        showingSettings.vendorInstructions;
      this.appointmentConfig.autoConfirm =
        showingSettings.approveShowingOptions.autoConfirm;
      this.appointmentConfig.listingAgentConfirm =
        showingSettings.approveShowingOptions.listingAgentConfirm;
      this.disableAutoConfirm =
        showingSettings.approveShowingOptions.listingAgentConfirm.enabled;
    });
  };

  changeDisplayToSellerToggle = (newToggle: boolean) => {
    this.$rootScope.$evalAsync(() => {
      this.appointmentConfig.displayedToSeller = newToggle;
    });
  };

  setShowingAgentInstructions = (showingAgentInstructions: any) => {
    this.$rootScope.$evalAsync(() => {
      if (
        this.appointmentConfig.preBookingInformation !==
        showingAgentInstructions.preBookingInformation
      ) {
        this.appointmentConfig.preBookingInformation =
          showingAgentInstructions.preBookingInformation;
      }

      if (this.appointmentConfig.access !== showingAgentInstructions.access) {
        this.selectAccessOption(showingAgentInstructions.access);

        // This is because ShowingAgentInstructions.tsx wants to update the details
        // as well, if the access type change is to SentriLock
        if (
          showingAgentInstructions.access === 'SentriLockV2' &&
          !this.appointmentConfig.instructions.sentrilockv2?.details &&
          showingAgentInstructions.sentrilockv2.details
        ) {
          this.appointmentConfig.instructions.sentrilockv2 = {
            ...this.appointmentConfig.instructions.sentrilockv2,
            details: showingAgentInstructions.sentrilockv2.details,
          };
        }
      } else {
        this.appointmentConfig.instructions.masterlock = {
          ...this.appointmentConfig.instructions.masterlock,
          details: showingAgentInstructions.masterlock.details,
        };
        this.appointmentConfig.instructions.supraekey = {
          ...this.appointmentConfig.instructions.supraekey,
          details: showingAgentInstructions.supraekey.details,
        };
        this.appointmentConfig.instructions.supralockbox = {
          ...this.appointmentConfig.instructions.supralockbox,
          details: showingAgentInstructions.supralockbox.details,
        };
        this.appointmentConfig.instructions.lockbox = {
          ...this.appointmentConfig.instructions.lockbox,
          details: showingAgentInstructions.lockbox.details,
          code: showingAgentInstructions.lockbox.code,
        };
        this.appointmentConfig.instructions.doorcode = {
          ...this.appointmentConfig.instructions.doorcode,
          details: showingAgentInstructions.doorcode.details,
          code: showingAgentInstructions.doorcode.code,
        };
        this.appointmentConfig.instructions.sentrilockv2 = {
          ...this.appointmentConfig.instructions.sentrilockv2,
          details: showingAgentInstructions.sentrilockv2.details,
        };
        this.appointmentConfig.instructions.sentrilockapp = {
          ...this.appointmentConfig.instructions.sentrilockapp,
          details: showingAgentInstructions.sentrilockapp.details,
        };
        this.appointmentConfig.instructions.direct = {
          ...this.appointmentConfig.instructions.direct,
          details: showingAgentInstructions.direct.details,
        };
        this.appointmentConfig.instructions.key = {
          ...this.appointmentConfig.instructions.key,
          details: showingAgentInstructions.key.details,
        };
        this.appointmentConfig.instructions.alarm = {
          ...this.appointmentConfig.instructions.alarm,
          details: showingAgentInstructions.alarm.details,
          code: showingAgentInstructions.alarm.code,
        };
        this.appointmentConfig.instructions.lights =
          showingAgentInstructions.lights;
        this.appointmentConfig.instructions.shoes =
          showingAgentInstructions.shoes;
        this.appointmentConfig.instructions.card =
          showingAgentInstructions.card;
        this.appointmentConfig.instructions.lock_doors =
          showingAgentInstructions.lock_doors;
        this.appointmentConfig.instructions.knockFirst =
          showingAgentInstructions.knockFirst;
        this.appointmentConfig.instructions.callIfLate =
          showingAgentInstructions.callIfLate;
        this.appointmentConfig.instructions.reco =
          showingAgentInstructions.reco;
        this.appointmentConfig.instructions.confirmation = {
          ...this.appointmentConfig.instructions.confirmation,
          details: showingAgentInstructions.confirmation.details,
        };
      }
    });
  };

  toggleVirtualShowings = () => {
    if (!this.appointmentConfig.isVirtualTourEnabled) {
      this.appointmentConfig.virtualTourProvider = '' as any;
      this.appointmentConfig.virtualTourIdentifier = '';
      this.virtualTourUrl = '';
      this.isVirtualTourUrlValid = null;
    }
    this.appointmentConfig.isVirtualTourEnabled =
      !this.appointmentConfig.isVirtualTourEnabled;
    this.$scope.$digest();
  };

  toggleAppointmentConfigSwitcher = (key: AppointmentConfigSwitch) => {
    this.appointmentConfigSwitch = key;
    this.$scope.$digest();
  };

  scrollTo = (x: string) => {
    const { $location, $anchorScroll } = this;
    const id = $location.hash();
    $location.hash(`anchor-${x}`);
    $anchorScroll();
    $location.hash(id);
  };

  scrollToAptRestrictions = () => this.scrollTo('appointmentRestrictions');

  closeLockboxPhotoEditor = () => {
    this.$rootScope.$evalAsync(() => {
      this.showLockboxPhotoEditor = false;
    });
  };

  updateLockboxPhoto = (lockboxPhoto?: string) => {
    this.appointmentConfig.lockboxPhoto = lockboxPhoto;
    this.closeLockboxPhotoEditor();
  };

  openFileUpload = () => {
    const { $rootScope } = this;

    if (this.appointmentConfig.lockboxPhoto) {
      this.lockboxPhoto = this.appointmentConfig.lockboxPhoto;
      this.newLockboxPhoto = true;
      $rootScope.$evalAsync(() => {
        this.showLockboxPhotoEditor = true;
      });
    } else {
      const picker = fileStackClient.picker({
        maxFiles: 1,
        accept: 'image/*',
        uploadInBackground: false,
        onFileSelected: file => {
          if (file.source === 'url' && !isValidUrl(file.originalPath))
            throw new Error('Invalid URL format. Please try again.');
        },
        onUploadDone: result => {
          if (result.filesUploaded?.length) {
            const attachment = result.filesUploaded[0];
            this.lockboxPhoto = attachment.url;
            this.newLockboxPhoto = false;
            $rootScope.$evalAsync(() => {
              this.showLockboxPhotoEditor = true;
            });
          }
        },
      });

      picker.open();
    }
  };

  areAppointmentInstructionsInvalid = () =>
    areAppointmentInstructionsInvalid(
      this.appointmentConfig.access,
      this.appointmentConfig.instructions,
    );

  onMasterLockValidate = (deviceId: string = null) => {
    // this line will make sure updated masterlock.deviceId value gets passed down to React component
    this.$scope.$evalAsync(() => {
      this.appointmentConfig.instructions.masterlock.deviceId = deviceId;
    });
  };

  // #endregion Lifecycle Methods

  // #region Methods

  createTimesForDay = () => {
    const day: Record<string, boolean> = {};
    for (let i = 7; i < 24; i += 1) {
      day[`${i}:00`] = true;
      day[`${i}:30`] = true;
    }
    return day;
  };

  initContacts = () => {
    this.AppointmentConfig.get(
      { listingId: this.listingId },
      (appointmentConfig: AppointmentConfig) => {
        const agentIds = appointmentConfig.contacts
          .filter(contact => contact.type === 'Agent')
          .map(contact => contact.contactId);
        this.loadContacts(
          this.$resource,
          this,
          this.$q,
          this.listingId,
          agentIds,
        ).catch(errorReporter.error);

        this.appointmentConfig.contacts = appointmentConfig.contacts;
      },
    );
  };

  getUnconfiguredErrors = (obj: Record<string, boolean> = {}) => {
    // Add more fields to the array when required in the future
    const res: string[] = [];
    if (!obj.access) res.push('Access Instructions');
    return res.join(', ');
  };

  setConfigFormDirty = () => {
    this.forms.configForm.$setDirty();
  };

  setConfigFormClean = () => {
    this.forms.configForm.$setPristine();
  };

  updateTimes = (
    timeslots: [DAYS, TIMES][],
    toValue: TimesStatus = 'Available',
  ) => {
    this.setConfigFormDirty();

    timeslots.forEach(([day, time]) => {
      this.appointmentConfig.days[day][time] = toValue;
    });
    this.appointmentConfig.advAutoConfEnabled = this.hasAutoConfEnabled(
      this.appointmentConfig.days,
    );
    // We need to reassign the actual object to let react know it's changed
    this.appointmentConfig.days = { ...this.appointmentConfig.days };
    // And then we need to call digest so angular knows to rerender
    setTimeout(() => this.$scope.$digest(), 0);
  };

  updateSpecialDays = (
    specialDays: Record<string, Record<string, boolean>>,
    timeslots?: [DAYS, TIMES][],
    toValue: TimesStatus = 'Available',
  ) => {
    this.setConfigFormDirty();
    if (specialDays) {
      this.appointmentConfig.specialTimes = { ...specialDays };
    } else {
      timeslots.forEach(([day, time]) => {
        // @ts-ignore
        this.appointmentConfig.specialTimes[day][time] = toValue;
      });

      this.appointmentConfig.advAutoConfEnabled = this.hasAutoConfEnabled(
        // @ts-ignore
        this.appointmentConfig.specialTimes,
      );

      this.appointmentConfig.specialTimes = {
        ...this.appointmentConfig.specialTimes,
      };
    }
    // Call digest so angular knows to rerender
    setTimeout(() => this.$scope.$digest(), 0);
  };

  updateLockboxHours = (accessHours: todo) => {
    this.setConfigFormDirty();
    this.supraLockboxAccessHours = accessHours;
    this.supraLockboxRestrictedHoursMap =
      buildLockboxRestrictedHoursMap(accessHours);
    // Call digest so angular knows to rerender
    setTimeout(() => this.$scope.$digest(), 0);
  };

  validatePhones = () => {
    const { contact } = this;
    if (!contact) return false;
    // dont try to validate agents phone numbers
    if ((contact as FIXME).type === 'Agent') return true;
    // if you have sent that you need to send sms or that
    // you must call then you must have a number
    return (
      contact.phone.filter(info => {
        if (info.sendSms || info.mustCall) {
          return !!info.number;
        }
        return true;
      }).length === contact.phone.length
    );
  };

  setAgentOnlyConfirm = () => {
    const setLAToConfirm = new this.SetLAToConfirm({
      listingId: this.listingId,
    });
    setLAToConfirm.$save(() => {
      this.initContacts();
    });
  };

  showNoMoreShowingsWarning = (noMoreShowings: boolean) => {
    this.NoMoreShowingsService.showNoMoreShowingsWarning(
      noMoreShowings,
      this.appointmentConfig.listingId,
      (noMoreShowingsSet: boolean) => {
        this.appointmentConfig.noMoreShowings = noMoreShowingsSet;
      },
    );
  };

  // {Mon:{"7:00":value}}
  hasAutoConfEnabled = (
    days: Record<DAYS, Record<TIMES, boolean | TimesStatus>>,
  ) =>
    Object.values(days).some(day => Object.values(day).includes('AutoConfirm'));

  setIsSupraLockCodeValid = (isValid: boolean) => {
    this.$scope.$evalAsync(() => {
      this.isSupraLockCodeValid = isValid;
    });
  };

  setIsMasterLockCodeValid = (isValid: boolean) => {
    // this line will make sure updated isMasterLockCodeValid value gets passed down to React component
    this.$scope.$evalAsync(() => {
      this.isMasterLockCodeValid = isValid;
    });
  };

  setIsMasterLockOneDayCodeEnabled = (enabled: boolean) => {
    this.$scope.$evalAsync(() => {
      this.appointmentConfig.instructions.masterlock!.isOneDayCodeEnabled =
        enabled;
    });
  };

  setSentriLockInfo = (
    info: Partial<ConfirmationInstructions['sentrilockv2']>,
  ) => {
    // since sentrilockInfo is passed to MasterlockValidator react component, this line will make sure the updated
    // sentrilockInfo is passed to the React component every time it gets updated
    this.$scope.$evalAsync(() => {
      this.appointmentConfig.instructions.sentrilockv2 = {
        ..._.cloneDeep(this.appointmentConfig.instructions.sentrilockv2),
        ...info,
      };
    });
  };

  setSupraLockInfo = (
    info: Partial<ConfirmationInstructions['supralockbox']>,
    reassign?: boolean,
  ) => {
    this.$scope.$evalAsync(() => {
      this.appointmentConfig.instructions.supralockbox = {
        ..._.cloneDeep(this.appointmentConfig.instructions.supralockbox),
        ...info,
      };
    });

    if (info?.serialNumber) {
      this.LockboxAccessHours.get({
        serialNumber: info.serialNumber,
        includeDefault: true,
      }).$promise.then(accessHours => {
        const { $promise, $resolved, customerDefaultHours, ...deviceHours } =
          accessHours;
        // If the lockbox is being reassigned from another listing
        // access hours should be set to customer defaults
        const hours = reassign ? accessHours.customerDefaultHours : deviceHours;
        const parsedHours = parseAccessHours(
          hours,
          info.productCode!,
        ) as AccessHoursType<Date>;
        this.supraLockboxAccessHours = parsedHours;
        this.supraLockboxRestrictedHoursMap =
          buildLockboxRestrictedHoursMap(parsedHours);
      });
    }
  };

  setOneDayCodeEnabled = (isOneDayCodeEnabled: boolean) => {
    this.appointmentConfig.instructions.sentrilockv2.isOneDayCodeEnabled =
      isOneDayCodeEnabled;
  };

  isNoticeOutOfRange = () => {
    const totalNoticeInMinutes =
      (+this.appointmentConfig.notice || 0) * 60 +
        +this.appointmentConfig.noticeMinutes || 0;

    return (
      totalNoticeInMinutes >= MAX_NOTICE_IN_MINUTES ||
      +this.appointmentConfig.notice < 0 ||
      +this.appointmentConfig.noticeMinutes > 60
    );
  };

  shouldDisableSave = () =>
    areAppointmentInstructionsInvalid(
      this.appointmentConfig.access,
      this.appointmentConfig.instructions,
    ) ||
    (this.appointmentConfig.access === 'SentriLockV2' &&
      !this.appointmentConfig.instructions.sentrilockv2.lbsn) ||
    (this.appointmentConfig.access === 'SentriLock' &&
      !this.isSentriLockCodeValid) ||
    (this.appointmentConfig.access === 'MasterLock' &&
      !this.isMasterLockCodeValid) ||
    (this.appointmentConfig.access === 'Supra Lockbox' &&
      !this.isSupraLockCodeValid) ||
    (this.appointmentConfig.isVirtualTourEnabled &&
      !this.isVirtualTourUrlValid) ||
    this.isNoticeOutOfRange();

  cancel = (listing: { id: string }) => {
    this.setConfigFormClean();
    let path = `/listing/${listing.id}/view`;
    if (!this.isModal) {
      if (this.appointmentId) {
        path = `/appointments/${this.appointmentId}/action`;
      }
      this.$location.path(path);
    }
  };

  saveForm = async (form: IFormController, trackEvent?: () => void) => {
    if (!form || !form.$valid) return;
    // If MasterLock deviceId is not valid
    if (
      this.appointmentConfig.access === 'MasterLock' &&
      !this.appointmentConfig.instructions.masterlock.deviceId
    ) {
      this.ToastService.add({
        type: 'warning',
        message: 'A valid Master Lock device ID must be provided.',
      });
      return;
    }

    const checkContactsPromise = new Promise<boolean>(res => {
      const contactsToConfirm =
        this.appointmentConfig.advAutoConfEnabled ||
        (!this.appointmentConfig.autoConfirm &&
          !this.appointmentConfig.listingAgentConfirm?.enabled);

      const hasSellerContact = this.appointmentConfig.contacts.some(contact =>
        ['Seller', 'Tenant', 'Landlord/Manager'].includes(contact.type),
      );

      if (contactsToConfirm && !hasSellerContact) {
        makeModalResponsive(
          Modal.confirm({
            title: 'Showing Configuration',
            content:
              'You have not added a seller/contact to confirm showings. To add a contact, you can click on the ‘Add Contact’ button below, or to continue, please press Save.',
            okText: 'Save',
            cancelText: 'Add Contact',
            onOk: () => {
              res(true);
            },
            onCancel: () => {
              this.ModalService.openContactModal();
              res(false);
            },
            centered: true,
          }),
          { dataCys: { content: 'confirm-save-config-modal' } },
        );
      } else {
        res(true);
      }
    });

    if (!(await checkContactsPromise)) {
      return;
    }

    const shouldConfirmMustCall =
      this.appointmentConfig.contacts.some(
        contact =>
          contact.phone &&
          contact.phone.some(phone => phone.mustCall && phone.number),
      ) &&
      (this.answeringSubscriptionExists === false ||
        this.listing.useAppointmentDesk === false) &&
      this.listing.country === 'USA';

    const canSubscribeToAnsweringService =
      this.listing.repsObjectIds.includes(this.$rootScope.auth.id) ||
      ROLES[this.$rootScope.auth.role as UserRoles] >= ROLES.GLOBAL_ADMIN;

    const confirmMustCallPromise = new Promise<boolean>(res => {
      if (!shouldConfirmMustCall) return res(true);

      ConfirmMustCallModal.open({
        onConfirm: () => res(true),
        onCancel: () => res(false),
        canSubscribeToAnsweringService,
      });
    });

    if (!(await confirmMustCallPromise)) {
      return;
    }

    this.dataLoaded = false;
    if (this.isNoticeOutOfRange()) {
      this.isInvalidNotice = true;
      this.dataLoaded = true;
      return;
    }

    // updating the useAppointmentDesk field for the listing in case it has changed
    if (this.useAppointmentDeskChanged) {
      const useAppointmentDesk = new this.UseAppointmentDesk({
        useAppointmentDesk: Boolean(this.listing.useAppointmentDesk),
      });
      useAppointmentDesk.$save();
    }

    const appointmentConfig = new this.AppointmentConfig({
      config: this.appointmentConfig,
      accessHours:
        this.supraLockboxAccessHours &&
        buildDKCoreDeviceAccessHours(this.supraLockboxAccessHours),
    });
    appointmentConfig
      .$save((updatedConfig: AppointmentConfig) => {
        const goToNextPath = () => {
          let path = `/listing/${this.listingId}/view`;
          if (this.appointmentId) {
            path = `/appointments/${this.appointmentId}/action`;
          }
          let search = {};
          if (shouldConfirmMustCall && canSubscribeToAnsweringService) {
            if (
              ROLES[this.$rootScope.auth.role as UserRoles] > ROLES.BRANCH_ADMIN
            ) {
              path = '/admin/appointment_desk';
            } else {
              path = '/profile';
              search = { tab: 'LIVE_CONCIERGE_SERVICE' };
            }
          }
          this.$location.path(path).search(search);
          form.$setSubmitted();
        };

        trackEvent?.();
        if (
          !this.appointmentConfig.pendingSentriLockAssignment &&
          updatedConfig.pendingSentriLockAssignment
        ) {
          this.dataLoaded = true;
          Modal.confirm({
            title: 'SentriLock Assignment Pending',
            content: this.listing.isIncomplete
              ? 'This Incomplete / Draft listing is not in the SentriLock system, we will attempt to automatically assign this lock box for you once the listing becomes Active.'
              : 'This listing is not yet in the SentriLock system, we will attempt to automatically assign this lock box later.',
            cancelButtonProps: { style: { display: 'none' } },
            onOk: () => {
              this.$scope.$evalAsync(() => {
                goToNextPath();
              });
            },
          });
        } else {
          goToNextPath();
        }
        message.success('Showing configurations updated');
      })

      .catch(err => {
        this.ErrorService.toastyHTTPErr(err);
        this.dataLoaded = true;
      });
  };

  private listingAgentConfirm: Partial<
    AppointmentConfig['listingAgentConfirm']
  > & {
    isSelected?: boolean;
  } = {};

  listingAgentConfirmChange = () => {
    if (this.listingAgentConfirm.isSelected) {
      this.appointmentConfig.listingAgentConfirm = {
        enabled: true,
        excludeFromQueue: false,
      };
      this.appointmentConfig.autoConfirm = false;
      this.contactsToConfirm = false;
      this.disableAutoConfirm = true;
      this.setAgentOnlyConfirm();
    } else {
      this.listingAgentConfirm.isSelected = true;
    }
  };

  setContactsToConfirm = () => {
    this.contactsToConfirm = true;
    this.disableAutoConfirm = false;
    this.listingAgentConfirm.isSelected = false;
    this.appointmentConfig.listingAgentConfirm = {
      enabled: false,
      excludeFromQueue: false,
    };
    this.appointmentConfig.autoConfirm = false;
  };

  doubleBookingToggle = () => {
    this.appointmentConfig.notifyOverlappingAppt = false;
    this.appointmentConfig.doubleBookings =
      !this.appointmentConfig.doubleBookings;
    this.$scope.$digest();
  };

  toggleOvernightNotice = () => {
    if (this.appointmentConfig.overnightNotice) {
      this.appointmentConfig.notice = undefined;
      this.appointmentConfig.noticeMinutes = undefined;
    }
  };

  toggleVendorInstruction = () => {
    this.showVendorInstruction = !this.showVendorInstruction;
  };

  toggleAlarmInstruction = () => {
    this.showAlarmInstruction = !this.showAlarmInstruction;
  };

  checkAlarmInstruction = () =>
    this.appointmentConfig?.instructions?.alarm?.code ||
    this.appointmentConfig?.instructions?.alarm?.details;

  toggleOtherInstruction = () => {
    this.showOtherInstruction = !this.showOtherInstruction;
  };

  checkOtherInstruction = () =>
    this.appointmentConfig?.instructions?.confirmation?.details;

  resetAppointmentConfigAccess = () => {
    this.appointmentConfig.access = '';
  };

  updateContacts = (contacts: ConfigContact[]) => {
    // this line will make sure updated shouldGetLockboxes value gets passed down to React component (SentrilockValidator)
    this.$scope.$evalAsync(() => {
      this.shouldGetLockboxes = true;
      this.appointmentConfig.contacts = contacts;
      // APP-772 Check concierge update
      const concierge = contacts.find(contact => contact.type === 'Concierge');
      this.appointmentConfig.holdAppointments =
        concierge && concierge.holdAppointments;
    });
  };

  setGetLockboxesFalse = () => {
    // this line will make sure updated shouldGetLockboxes value gets passed down to React component (SentrilockValidator)
    this.$scope.$evalAsync(() => {
      this.shouldGetLockboxes = false;
    });
  };

  selectAccessOption = (labelId: AccessType) => {
    this.appointmentConfig.access = labelId;
  };

  // This method is used for the deprecated access (SentriLock)
  validateSentriLock = (lbsn: string) => {
    const ValidateSentriLock = this.$resource(
      `/listing/${this.listingId}/appointments/sentrilock/:lbsn`,
      {
        lbsn: '@lbsn',
      },
    );

    this.validatingSentriLock = true;

    return ValidateSentriLock.get({
      listingId: this.listingId,
      lbsn,
      date: moment().format('YYYY-MM-DD'),
    })
      .$promise.then(({ valid }) => {
        this.isSentriLockCodeValid = valid;
      })
      .catch(errorReporter.error)
      .finally(() => {
        this.validatingSentriLock = false;
      });
  };

  toggleUseAppointmentDesk = () => {
    // Due to the nature that useAppointmentDesk can both be null/true to be truthy
    this.listing.useAppointmentDesk = this.listing.useAppointmentDesk === false;
    this.useAppointmentDeskChanged = !this.useAppointmentDeskChanged;
  };

  toggleNoMoreShowing = () => {
    this.showNoMoreShowingsWarning(!this.appointmentConfig.noMoreShowings);
  };

  hideUpdateShowings = () => {
    this.$rootScope.$evalAsync(() => {
      this.updateShowingsVisible = false;
    });
  };

  hasLimitedAccess = () =>
    isLimitedAccessOnUnclaimedBrokerage(
      this.$rootScope.auth,
      this.$rootScope.orgStatus,
      this.$rootScope.currentPlan,
    );

  noEmptyValues = (obj: Record<string, any>) =>
    Object.keys(obj).reduce(
      (acc, key) => {
        if (typeof obj[key] === 'object') {
          const recr = this.noEmptyValues(obj[key]);
          if (Object.keys(recr).length) acc[key] = recr;
        } else if (obj[key] !== '' && obj[key] != null) {
          acc[key] = obj[key];
        }
        return acc;
      },
      {} as Record<string, any>,
    );

  submit = (form: IFormController, trackEvent: () => void) => {
    const isAccessSettingsEqual = (
      config1: AppointmentConfig,
      config2: AppointmentConfig,
    ) => {
      const parsedConfig1 = {
        access: config1.access,
        instructions: parseInstructions(config1.access, config1.instructions, {
          includeCommonFields: false,
        }),
      };

      const parsedConfig2 = {
        access: config2.access,
        instructions: parseInstructions(config2.access, config2.instructions, {
          includeCommonFields: false,
        }),
      };

      return _.isEqual(parsedConfig1, parsedConfig2);
    };

    const addToExcludeList: AppointmentStatus[] = [];
    if (
      isAccessSettingsEqual(
        this.originalShowingsConfig,
        this.appointmentConfig,
      ) ||
      this.appointmentConfig.access === ''
    ) {
      addToExcludeList.push('confirm');
    }
    if (
      this.originalShowingsConfig.autoConfirm ||
      !this.appointmentConfig.autoConfirm
    ) {
      addToExcludeList.push('new');
    }
    this.excludedShowings = addToExcludeList;

    if (
      (['new', 'confirm'] as AppointmentStatus[]).every(status =>
        addToExcludeList.includes(status),
      )
    ) {
      return this.saveForm(form, trackEvent);
    }

    this.$rootScope.$evalAsync(() => {
      this.saveShowingsConfig = () => this.saveForm(form, trackEvent);
      this.updateShowingsVisible = true;
    });
  };

  // #endregion Methods

  // #region Members

  private forms: {
    configForm: IFormController;
  } = {} as any;

  contactTypes = ['Seller', 'Tenant', 'Landlord/Manager', 'Agent'];

  contactImportance = ['Primary', '2nd', '3rd', 'Other'];

  private otherAccessOptions = [
    { id: 'Lock Box', label: 'Combination Lock Box' },
    { id: 'Direct', label: 'Direct' },
    { id: 'Key', label: 'Key' },
    { id: 'Door Code', label: 'Door Code' },
  ];

  private sentriLockAccessOptions = [
    { id: 'SentriLockV2', label: 'SentriLock' },
  ];

  private legacySentriLockAccessOptions = [
    { id: 'SentriLock', label: 'SentriLock 1-Day Code' },
    { id: 'SentriLock App', label: 'SentriLock App' },
  ];

  private masterLockAccessOptions = [
    { id: 'MasterLock', label: 'Master Lock' },
  ];

  private supraEkeyAccessOptions = [{ id: 'Supra eKEY', label: 'Supra eKEY' }];

  private supraLockBoxAccessOptions = [{ id: 'Supra Lockbox', label: 'Supra' }];

  private accesses = [
    { id: '', label: '' },
    ...this.otherAccessOptions,
    ...this.sentriLockAccessOptions,
    ...this.legacySentriLockAccessOptions,
    ...this.masterLockAccessOptions,
    ...this.supraEkeyAccessOptions,
    ...this.supraLockBoxAccessOptions,
  ];

  accessesMap = this.accesses.reduce(
    (mapObj, { id, label }) => ({ ...mapObj, [id]: label }),
    {},
  );

  private accessInstructionNames: (AccessKey | 'none')[] = [
    'none',
    'lockbox',
    'direct',
    'key',
    'doorcode',
    'sentrilock',
    'sentrilockapp',
    'sentrilockv2',
    'masterlock',
    'supraekey',
    'supralockbox',
  ];

  restrictions = {};

  notifications: NotificationLabels[] = [
    'Booked',
    'Confirmed',
    'Cancelled',
    'Deny',
    'Time Change',
    'Action Required',
    'Feedback Collected',
  ];

  deliveries = ['Email'];

  private days: DAYS[] = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];

  weekdays: DAYS[] = ['MON', 'TUE', 'WED', 'THU', 'FRI'];

  weekends: DAYS[] = ['SAT', 'SUN'];

  dayTimes = {};

  unavailableDays: string[] = [];

  // #endregion Members
}

angular.module('bb.appointments').component('bbAppointmentConfig', {
  bindings: {
    config: '<',
    listingId: '<',
    appointmentId: '<',
    template: '@',
  },
  controller: AppointmentConfigCtrl,
  template: pageTemplate,
});

AppointmentConfigCtrl.$inject = [
  '$scope',
  '$resource',
  '$rootScope',
  '$location',
  '$routeParams',
  '$timeout',
  '$q',
  '$anchorScroll',
  'loadContacts',
  'NoMoreShowingsService',
  'ToastService',
  'AppointmentConfigService',
  'ErrorService',
  'ModalService',
];
